// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  DeleteData,
  DeleteErrors,
  DeleteProjectsByProjectIdFeaturesByIdData,
  DeleteProjectsByProjectIdFeaturesByIdErrors,
  DeleteProjectsByProjectIdFeaturesByIdResponses,
  DeleteProjectsByProjectIdFeaturesData,
  DeleteProjectsByProjectIdFeaturesErrors,
  DeleteProjectsByProjectIdFeaturesMetadataData,
  DeleteProjectsByProjectIdFeaturesMetadataErrors,
  DeleteProjectsByProjectIdFeaturesMetadataResponses,
  DeleteProjectsByProjectIdFeaturesResponses,
  DeleteProjectsByProjectIdFeaturesTagsData,
  DeleteProjectsByProjectIdFeaturesTagsErrors,
  DeleteProjectsByProjectIdFeaturesTagsResponses,
  DeleteResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectResponses,
  GetProjectsByProjectIdFeaturesAggregationsData,
  GetProjectsByProjectIdFeaturesAggregationsErrors,
  GetProjectsByProjectIdFeaturesAggregationsResponses,
  GetProjectsByProjectIdFeaturesByIdData,
  GetProjectsByProjectIdFeaturesByIdErrors,
  GetProjectsByProjectIdFeaturesByIdResponses,
  GetProjectsByProjectIdFeaturesData,
  GetProjectsByProjectIdFeaturesErrors,
  GetProjectsByProjectIdFeaturesImportsStatusData,
  GetProjectsByProjectIdFeaturesImportsStatusErrors,
  GetProjectsByProjectIdFeaturesImportsStatusResponses,
  GetProjectsByProjectIdFeaturesResponses,
  GetProjectsByProjectIdFeaturesTilesByZoomByXByYData,
  GetProjectsByProjectIdFeaturesTilesByZoomByXByYErrors,
  GetProjectsByProjectIdFeaturesTilesByZoomByXByYResponses,
  GetProjectsByProjectIdLayersByLayerIdLastModifiedData,
  GetProjectsByProjectIdLayersByLayerIdLastModifiedErrors,
  GetProjectsByProjectIdLayersByLayerIdLastModifiedResponses,
  GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYData,
  GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYErrors,
  GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYResponses,
  GetProjectsByProjectIdTilesByZoomByXByYData,
  GetProjectsByProjectIdTilesByZoomByXByYErrors,
  GetProjectsByProjectIdTilesByZoomByXByYResponses,
  GetProjectsData,
  GetProjectsErrors,
  GetProjectsResponses,
  PatchProjectsByProjectIdFeaturesData,
  PatchProjectsByProjectIdFeaturesErrors,
  PatchProjectsByProjectIdFeaturesMetadataData,
  PatchProjectsByProjectIdFeaturesMetadataErrors,
  PatchProjectsByProjectIdFeaturesMetadataResponses,
  PatchProjectsByProjectIdFeaturesResponses,
  PatchProjectsByProjectIdFeaturesTagsData,
  PatchProjectsByProjectIdFeaturesTagsErrors,
  PatchProjectsByProjectIdFeaturesTagsResponses,
  PostProjectsByProjectIdFeaturesData,
  PostProjectsByProjectIdFeaturesDeleteData,
  PostProjectsByProjectIdFeaturesDeleteErrors,
  PostProjectsByProjectIdFeaturesDeleteResponses,
  PostProjectsByProjectIdFeaturesErrors,
  PostProjectsByProjectIdFeaturesImportsData,
  PostProjectsByProjectIdFeaturesImportsErrors,
  PostProjectsByProjectIdFeaturesImportsResponses,
  PostProjectsByProjectIdFeaturesResponses,
  PostProjectsData,
  PostProjectsErrors,
  PostProjectsResponses,
  PutProjectsByProjectIdFeaturesAggregationsData,
  PutProjectsByProjectIdFeaturesAggregationsErrors,
  PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedData,
  PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedErrors,
  PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedResponses,
  PutProjectsByProjectIdFeaturesAggregationsResponses,
  PutProjectsByProjectIdFeaturesLayersLayerGeomTypeData,
  PutProjectsByProjectIdFeaturesLayersLayerGeomTypeErrors,
  PutProjectsByProjectIdFeaturesLayersLayerGeomTypeResponses,
  PutProjectsByProjectIdFeaturesQueryData,
  PutProjectsByProjectIdFeaturesQueryErrors,
  PutProjectsByProjectIdFeaturesQueryResponses,
  PutProjectsByProjectIdLayersLastModifiedData,
  PutProjectsByProjectIdLayersLastModifiedErrors,
  PutProjectsByProjectIdLayersLastModifiedResponses,
  ScrollFeaturesData,
  ScrollFeaturesErrors,
  ScrollFeaturesResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get aggregation
 *
 * Used to perform a limited set of summary statistics, Min, Max, and Count, on a property value, over a feature collection.
 * The bounds of the features can also be obtained using the GeoBounds aggregation operation.
 */
export const getProjectsByProjectIdFeaturesAggregations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdFeaturesAggregationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdFeaturesAggregationsResponses,
    GetProjectsByProjectIdFeaturesAggregationsErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/aggregations', ...options });

/**
 * Bulk aggregations query.
 *
 * Perform multiple aggregations, in batch.
 */
export const putProjectsByProjectIdFeaturesAggregations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdFeaturesAggregationsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdFeaturesAggregationsResponses,
    PutProjectsByProjectIdFeaturesAggregationsErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/aggregations',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Request to obtain max last-modified-utc for the set of specified layers.
 */
export const putProjectsByProjectIdFeaturesAggregationsMaxLastModified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedData,
    ThrowOnError
  >
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedResponses,
    PutProjectsByProjectIdFeaturesAggregationsMaxLastModifiedErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/aggregations/maxLastModified',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Delete metadata property
 */
export const deleteProjectsByProjectIdFeaturesMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdFeaturesMetadataData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdFeaturesMetadataResponses,
    DeleteProjectsByProjectIdFeaturesMetadataErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/metadata', ...options });

/**
 * Patch metadata.
 */
export const patchProjectsByProjectIdFeaturesMetadata = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchProjectsByProjectIdFeaturesMetadataData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchProjectsByProjectIdFeaturesMetadataResponses,
    PatchProjectsByProjectIdFeaturesMetadataErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/metadata',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Soft-deletes features.
 */
export const deleteProjectsByProjectIdFeatures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdFeaturesResponses,
    DeleteProjectsByProjectIdFeaturesErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Query features.
 */
export const getProjectsByProjectIdFeatures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdFeaturesResponses,
    GetProjectsByProjectIdFeaturesErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features', ...options });

/**
 * Patch features.
 *
 * Features must conform to the GeoJSON spec - see https://tools.ietf.org/html/rfc7946
 */
export const patchProjectsByProjectIdFeatures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchProjectsByProjectIdFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchProjectsByProjectIdFeaturesResponses,
    PatchProjectsByProjectIdFeaturesErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Store features.
 *
 * Features must conform to the GeoJSON spec - see https://tools.ietf.org/html/rfc7946
 * To opt in to optimistic concurrency control, include an If-Match header containing the ETag value of the FeatureCollection when read.
 */
export const postProjectsByProjectIdFeatures = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdFeaturesResponses,
    PostProjectsByProjectIdFeaturesErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Soft-deletes a specified feature.
 */
export const deleteProjectsByProjectIdFeaturesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdFeaturesByIdData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdFeaturesByIdResponses,
    DeleteProjectsByProjectIdFeaturesByIdErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/{id}', ...options });

/**
 * Request an individual feature, by Id.
 */
export const getProjectsByProjectIdFeaturesById = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdFeaturesByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdFeaturesByIdResponses,
    GetProjectsByProjectIdFeaturesByIdErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/{id}', ...options });

/**
 * Non-mutable PUT to query for features.
 */
export const putProjectsByProjectIdFeaturesQuery = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdFeaturesQueryData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdFeaturesQueryResponses,
    PutProjectsByProjectIdFeaturesQueryErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/query',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Scroll features.
 */
export const scrollFeatures = <ThrowOnError extends boolean = false>(
  options: Options<ScrollFeaturesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ScrollFeaturesResponses,
    ScrollFeaturesErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/_scroll',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Bulk soft-deletes features, via POST.
 */
export const postProjectsByProjectIdFeaturesDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdFeaturesDeleteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdFeaturesDeleteResponses,
    PostProjectsByProjectIdFeaturesDeleteErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/_delete',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Returns a dictionary of layer geometry types, keyed on the supplied layerIds.
 */
export const putProjectsByProjectIdFeaturesLayersLayerGeomType = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    PutProjectsByProjectIdFeaturesLayersLayerGeomTypeData,
    ThrowOnError
  >
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdFeaturesLayersLayerGeomTypeResponses,
    PutProjectsByProjectIdFeaturesLayersLayerGeomTypeErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/layers/layerGeomType',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Import features from a file uploaded by the end user, or from a file already stored in Trimble Connect
 */
export const postProjectsByProjectIdFeaturesImports = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PostProjectsByProjectIdFeaturesImportsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    PostProjectsByProjectIdFeaturesImportsResponses,
    PostProjectsByProjectIdFeaturesImportsErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/projects/{projectId}/features/imports',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Gets the status of background global geometry transforms, for a specified set of features.
 */
export const getProjectsByProjectIdFeaturesImportsStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdFeaturesImportsStatusData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdFeaturesImportsStatusResponses,
    GetProjectsByProjectIdFeaturesImportsStatusErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/imports/status', ...options });

/**
 * Delete a tag
 */
export const deleteProjectsByProjectIdFeaturesTags = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteProjectsByProjectIdFeaturesTagsData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteProjectsByProjectIdFeaturesTagsResponses,
    DeleteProjectsByProjectIdFeaturesTagsErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/tags', ...options });

/**
 * Add a tag.
 */
export const patchProjectsByProjectIdFeaturesTags = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PatchProjectsByProjectIdFeaturesTagsData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchProjectsByProjectIdFeaturesTagsResponses,
    PatchProjectsByProjectIdFeaturesTagsErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/features/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * Lists user's project info.
 */
export const getProjects = <ThrowOnError extends boolean = false>(
  options?: Options<GetProjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetProjectsResponses,
    GetProjectsErrors,
    ThrowOnError
  >({ url: '/projects', ...options });

/**
 * Create a tenancy for the specified Connect project.
 */
export const postProjects = <ThrowOnError extends boolean = false>(
  options?: Options<PostProjectsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    PostProjectsResponses,
    PostProjectsErrors,
    ThrowOnError
  >({ url: '/projects', ...options });

/**
 * Caution! Permanently deletes the project tenancy, including all features.
 */
export const delete_ = <ThrowOnError extends boolean = false>(
  options: Options<DeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteResponses,
    DeleteErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}', ...options });

/**
 * Get a specific Project.
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectResponses,
    GetProjectErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}', ...options });

/**
 * Request for a tile.
 */
export const getProjectsByProjectIdTilesByZoomByXByY = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectsByProjectIdTilesByZoomByXByYData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdTilesByZoomByXByYResponses,
    GetProjectsByProjectIdTilesByZoomByXByYErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/tiles/{zoom}/{x}/{y}', ...options });

/**
 * Request for a tile.
 */
export const getProjectsByProjectIdFeaturesTilesByZoomByXByY = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdFeaturesTilesByZoomByXByYData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdFeaturesTilesByZoomByXByYResponses,
    GetProjectsByProjectIdFeaturesTilesByZoomByXByYErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/features/tiles/{zoom}/{x}/{y}', ...options });

/**
 * Request for a tile, on a specified layer.
 */
export const getProjectsByProjectIdLayersByLayerIdTilesByZoomByXByY = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYResponses,
    GetProjectsByProjectIdLayersByLayerIdTilesByZoomByXByYErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/layers/{layerId}/tiles/{zoom}/{x}/{y}',
    ...options,
  });

/**
 * Returns a layer's last-modified utc timestamp.
 */
export const getProjectsByProjectIdLayersByLayerIdLastModified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetProjectsByProjectIdLayersByLayerIdLastModifiedData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    GetProjectsByProjectIdLayersByLayerIdLastModifiedResponses,
    GetProjectsByProjectIdLayersByLayerIdLastModifiedErrors,
    ThrowOnError
  >({ url: '/projects/{projectId}/layers/{layerId}/lastModified', ...options });

/**
 * Returns a dictionary of last-modified utc timestamps, keyed on the supplied layerIds.
 */
export const putProjectsByProjectIdLayersLastModified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PutProjectsByProjectIdLayersLastModifiedData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutProjectsByProjectIdLayersLastModifiedResponses,
    PutProjectsByProjectIdLayersLastModifiedErrors,
    ThrowOnError
  >({
    url: '/projects/{projectId}/layers/lastModified',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });
